import { t } from "i18next";

const buildGoalsList = (assessment_plan, terms) => {
  const goalsSet = new Set();
  const objectivesSet = new Set();
  const goalsList = [];
  // Convert assessing_terms from ids to names
  assessment_plan.sections.forEach((section) => {
    section.assessments
      .filter((assessment) => !!assessment.id)
      .forEach((assessment) => {
        if (terms) {
          assessment.assessing_terms.forEach((t, i) => {
            assessment.assessing_terms[i] = terms.find(
              (term) => term.id === t
            ).name;
          });
        }
        if (!assessment.objective?.id) {
          assessment.objective = {
            id: "0",
            description: t("dashboard.noObjectiveAssociated"),
          };
        }
        if (!goalsSet.has(assessment.goal.id)) {
          goalsSet.add(assessment.goal.id);
          goalsList.push({
            description: assessment.goal.description,
            id: assessment.goal.id,
            objectives: [
              {
                ...assessment.objective,
                assessments: [assessment],
                measures: [],
              },
            ],
          });
          objectivesSet.add(assessment.objective.id);
        } else {
          if (!objectivesSet.has(assessment.objective.id)) {
            objectivesSet.add(assessment.objective.id);
            goalsList.forEach((oldGoal, idx) => {
              if (oldGoal.id === assessment.goal.id) {
                if (!Object.hasOwn(goalsList[idx], "objectives")) {
                  goalsList[idx].objectives = [];
                }
                goalsList[idx].objectives.push({
                  description: assessment.objective.description,
                  id: assessment.objective.id,
                  assessments: [assessment],
                  measures: [],
                });
              }
            });
          } else {
            goalsList.forEach((oldGoal, idx) => {
              if (oldGoal.id === assessment.goal.id) {
                goalsList[idx].objectives.forEach((objective, index) => {
                  if (objective.id === assessment.objective.id) {
                    goalsList[idx].objectives[index].assessments.push(
                      assessment
                    );
                  }
                });
              }
            });
          }
        }
      });

    section.qualitative_measures
      .filter((qm) => !!qm.ddl_id)
      .forEach((qm) => {
        if (!qm.objective.id) {
          qm.objective.id = "0";
          qm.objective.description = t("dashboard.noObjectiveAssociated");
        }
        if (!goalsSet.has(qm.goal.id)) {
          goalsSet.add(qm.goal.id);

          goalsList.push({
            description: qm.goal.description,
            id: qm.goal.id,
            objectives: [{ ...qm.objective, assessments: [], measures: [qm] }],
          });
          objectivesSet.add(qm.objective.id);
        } else {
          if (!objectivesSet.has(qm.objective.id)) {
            objectivesSet.add(qm.objective.id);
            goalsList.forEach((oldGoal, idx) => {
              if (oldGoal.id === qm.goal.id) {
                if (!Object.hasOwn(goalsList[idx], "objectives")) {
                  goalsList[idx].objectives = [];
                }
                goalsList[idx].objectives.push({
                  description: qm.objective.description,
                  id: qm.objective.id,
                  assessments: [],
                  measures: [qm],
                });
              }
            });
          } else {
            goalsList.forEach((oldGoal, idx) => {
              if (oldGoal.id === qm.goal.id) {
                goalsList[idx].objectives.forEach((objective, index) => {
                  if (objective.id === qm.objective.id) {
                    goalsList[idx].objectives[index].measures.push(qm);
                  }
                });
              }
            });
          }
        }
      });
  });
  return goalsList;
};

export default buildGoalsList;
